import { createAction } from '@reduxjs/toolkit';
import {
  ActiveProjectSearchDTO,
  GetCustomersDTO,
  KontentLanguageDTO,
  KontentProjectOverviewDTO,
  XTMProjectDTO,
} from 'utils/restApplicationClient';
import { GetTemplatesDTO } from 'utils/restApplicationClientTypeOverrides';
import { SettingsActionTypes } from './settings.actions.types';

export const getCustomers = createAction(SettingsActionTypes.GetCustomers);

export const getCustomersSuccess = createAction<GetCustomersDTO>(SettingsActionTypes.GetCustomersSuccess);

export const getCustomersError = createAction(SettingsActionTypes.GetCustomersError);

export const getTemplatesByCustomerId = createAction<number>(SettingsActionTypes.GetTemplatesByCustomerId);

export const getTemplatesByCustomerIdSuccess = createAction<GetTemplatesDTO>(
  SettingsActionTypes.GetTemplatesByCustomerIdSuccess,
);

export const getTemplatesByCustomerIdError = createAction(SettingsActionTypes.GetTemplatesByCustomerIdError);

export const getActiveProjects = createAction<ActiveProjectSearchDTO>(SettingsActionTypes.GetActiveProjects);

export const getActiveProjectsSuccess = createAction<XTMProjectDTO[]>(SettingsActionTypes.GetActiveProjectsSuccess);

export const getActiveProjectsError = createAction(SettingsActionTypes.GetActiveProjectsError);

export const clearSettings = createAction(SettingsActionTypes.ClearSettings);

export const clearActiveProjects = createAction(SettingsActionTypes.ClearActiveProjects);

export const getKenticoProjects = createAction(SettingsActionTypes.GetKenticoProjects);

export const getKenticoProjectsError = createAction(SettingsActionTypes.GetKenticoProjectsError);

export const getKenticoProjectsSuccess = createAction<KontentProjectOverviewDTO[]>(
  SettingsActionTypes.GetKenticoProjectsSuccess,
);

export const getAvailableLanguages = createAction(SettingsActionTypes.GetAvailableLanguages);

export const getAvailableLanguagesSuccess = createAction<KontentLanguageDTO[]>(
  SettingsActionTypes.GetAvailableLanguagesSuccess,
);

export const getAvailableLanguagesError = createAction(SettingsActionTypes.GetAvailableLanguagesError);
